import React from "react";
import TypedText from "../Package/TypedText";

function Hero() {
  return (
    <>
      {/* #HERO */}
      <section className="hero section" id="home" aria-label="home">
        <div className="container">
          <div className="hero-banner">
            <img
              src= "/assets/images/model-main.png"
              width={327}
              height={490}
              alt="Prabhjeet Singh"
              className="w-100"
            />
            <img
              src="/assets/images/pattern-2.svg"
              width={27}
              height={26}
              alt="shape"
              className="shape shape-1"
            />
            <img
              src= "/assets/images/pattern-3.svg"
              width={27}
              height={26}
              alt="shape"
              className="shape shape-2"
            />
          </div>
          <div className="hero-content">
            <p className="hero-subtitle">Hello Everyone!</p>
            <h1 className="headline headline-1 section-title">
              <span>It's Me</span>
              <span className="span">Prabhjeet Singh</span>
            </h1>
            <h3
              className="headline headline-3 section-title"
              style={{ display: "flex" }}
            >
              <span>I'm a&nbsp;</span>
              <TypedText />
            </h3>
            <span className="hero-text">
              Welcome to my world of boundless exploration and relentless
              pursuit of dreams. I am Prabhjeet Singh, a living testament to the
              potential that lies within the intersections of passion, talent,
              and ambition.
            </span>
            <div className="input-wrapper">
              <input
                type="email"
                name="email_address"
                placeholder="Enter your email address"
                required=""
                className="input-field"
                autoComplete="off"
              />
              <button className="btn btn-primary">
                <p className="span">Subscribe</p>
                <ion-icon name="arrow-forward-outline" aria-hidden="true" />
              </button>
            </div>
          </div>
          {/* <img src="./assets/images/shadow-1.svg" width="500" height="800" alt="" class="hero-bg hero-bg-1">
    <img src="./assets/images/shadow-2.svg" width="500" height="500" alt="" class="hero-bg hero-bg-2"> */}
        </div>
      </section>
    </>
  );
}

export default Hero;
